import React from 'react'
import FabricationHeader from '../../Components/FabricationHeader'
import Navbar from '../../Components/Navbar'
import FabricationServices from '../../Components/FabricationServices'
import Footer from '../../Components/Footer'

const Fabrication = () => {
  return (
    <div>
      <Navbar/>
      <FabricationHeader/>
      <FabricationServices/>
      <Footer/>
    </div>
  )
}

export default Fabrication
